import React from 'react';
import { Layout } from 'containers';
import PrivateRoute from './PrivateRoute';
import ValidatorRoute from './ValidatorRoute';

const LayoutRoute = ({ isPrivate = true, children, ...props }) =>
  isPrivate ? (
    <Layout>
      <PrivateRoute {...props}>{children}</PrivateRoute>
    </Layout>
  ) : (
    <Layout>
      <ValidatorRoute {...props}>{children}</ValidatorRoute>
    </Layout>
  );

export default LayoutRoute;
